export const layout = {
  title: 2,
  fosfaatInterval: 1,
  break: 2,
  grondInterval: 1,
  kenmerkenGrondInterval: 2,
};

export const koolstofLayout = {
  title: 4,
  inputGrondenInterval: 2,
  inputKenmerkenInterval: 4,
  inputGrondenTitleInterval: 4,
  break: 4,
};
